import React, { useEffect, useState, useCallback, useRef, } from 'react';
import Cookies from 'js-cookie';
import { decodeJwt } from 'jose';
export default function JwtRefresher({ initialToken = '', cookieName = '', checkIntervalSeconds = 60, refreshTimeBeforeExpirySeconds = 3600, refreshIframeUrl = '', onRefreshing = () => { }, onRefreshed = () => { }, maxRetries = 3, }) {
    const iframe = useRef(null);
    const retryNumber = useRef(0);
    const [showIframe, setShowIframe] = useState(false);
    const [currentToken, setCurrentToken] = useState(initialToken);
    const isTokenValid = useCallback((tokenString) => {
        if (!tokenString) {
            return false;
        }
        let token;
        try {
            token = decodeJwt(tokenString);
        }
        catch (e) {
            return false;
        }
        if (!token || typeof token.exp !== 'number') {
            return false;
        }
        const now = Math.floor((new Date()).getTime() / 1000);
        return token.exp > now + refreshTimeBeforeExpirySeconds;
    }, [refreshTimeBeforeExpirySeconds]);
    const tryRefreshFromCookie = useCallback(() => {
        if (!cookieName) {
            return false;
        }
        const cookieToken = Cookies.get(cookieName);
        if (cookieToken !== currentToken && isTokenValid(cookieToken)) {
            setCurrentToken(cookieToken);
            onRefreshed(cookieToken);
            retryNumber.current = 0;
            return true;
        }
        return false;
    }, [cookieName, currentToken, isTokenValid, onRefreshed]);
    const check = useCallback(() => {
        var _a, _b;
        if (retryNumber.current >= maxRetries) {
            return;
        }
        if (!isTokenValid(currentToken)) {
            if (tryRefreshFromCookie()) {
                return;
            }
            retryNumber.current += 1;
            onRefreshing(currentToken, retryNumber);
            if (refreshIframeUrl) {
                if (!showIframe) {
                    setShowIframe(true);
                }
                else {
                    (_b = (_a = iframe.current.contentWindow) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
                }
            }
        }
    }, [
        currentToken,
        isTokenValid,
        maxRetries,
        onRefreshing,
        refreshIframeUrl,
        showIframe,
        tryRefreshFromCookie,
    ]);
    useEffect(() => {
        const interval = setInterval(check, checkIntervalSeconds * 1000);
        return () => clearInterval(interval);
    }, [check, checkIntervalSeconds, currentToken]);
    setTimeout(check, 1);
    return (showIframe && (React.createElement("iframe", { ref: iframe, style: { display: 'none' }, title: "jwt-refresher", src: refreshIframeUrl, onLoad: tryRefreshFromCookie })));
}
